import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { roundToDecimals } from '~/modules/resourcing/common/util/scheduleUtil';
import { ADD_RESOURCE_ESTIMATE_DIALOG_TABS } from './constants';
import AddResourceEstimateDialogContentLoading from './AddResourceEstimateDialogContentLoading';
import PlaceholderFormContent from './PlaceholderFormContent';
import ResourceFormContent from './ResourceFormContent';

const AddResourceEstimateDialogContent3 = ({
  activeTab,
  task,
  onClose,
  resourceEstimates,
  setParentFieldValue,
  canViewCost,
  isFullVersionEnabled,
  resourceEstimate,
  isCreateTaskAllocationEnabled,
  totalResourceEstimateHours,
  loading,
  setIsDirty
}) => {
  const isEditMode = Boolean(resourceEstimate);

  const computedInitialHours = useMemo(() => {
    if (isEditMode) return resourceEstimate.initialEstimatedHours;

    return task.initialEstimatedHours > totalResourceEstimateHours
      ? roundToDecimals(task.initialEstimatedHours - totalResourceEstimateHours)
      : null;
  }, [isEditMode, resourceEstimate, task, totalResourceEstimateHours]);

  if (loading) {
    return (
      <AddResourceEstimateDialogContentLoading
        isFullVersionEnabled={isFullVersionEnabled}
      />
    );
  }

  if (activeTab === ADD_RESOURCE_ESTIMATE_DIALOG_TABS.PLACEHOLDER) {
    return (
      <PlaceholderFormContent
        task={task}
        onClose={onClose}
        isEditMode={isEditMode}
        setIsDirty={setIsDirty}
        computedInitialHours={computedInitialHours}
        resourceEstimate={resourceEstimate}
        resourceEstimates={resourceEstimates}
        setParentFieldValue={setParentFieldValue}
        canViewCost={canViewCost}
      />
    );
  }

  return (
    <ResourceFormContent
      task={task}
      onClose={onClose}
      isEditMode={isEditMode}
      isFullVersionEnabled={isFullVersionEnabled}
      setIsDirty={setIsDirty}
      computedInitialHours={computedInitialHours}
      resourceEstimate={resourceEstimate}
      resourceEstimates={resourceEstimates}
      setParentFieldValue={setParentFieldValue}
      canViewCost={canViewCost}
      isCreateTaskAllocationEnabled={isCreateTaskAllocationEnabled}
    />
  );
};

AddResourceEstimateDialogContent3.propTypes = {
  activeTab: PropTypes.string.isRequired,
  task: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  resourceEstimates: PropTypes.array.isRequired,
  setParentFieldValue: PropTypes.func.isRequired,
  canViewCost: PropTypes.bool.isRequired,
  isFullVersionEnabled: PropTypes.bool.isRequired,
  resourceEstimate: PropTypes.object,
  isCreateTaskAllocationEnabled: PropTypes.bool,
  totalResourceEstimateHours: PropTypes.number,
  loading: PropTypes.bool.isRequired,
  setIsDirty: PropTypes.func.isRequired
};

export default AddResourceEstimateDialogContent3;
